import {
  PROFILE_LOADING,
  PROFILE_SET_DATA,
  PROFILE_SET_DATA_ERROR,
  PROFILE_EDIT_START,
  PROFILE_EDIT_SUCCESS,
  PROFILE_EDIT_FAILURE,
  GET_OTHER_PROFILE_START,
  GET_OTHER_PROFILE_SUCCESS,
  GET_OTHER_PROFILE_FAILURE
} from "./constants";
import { setUserId } from "../../utils/authManager";

const initialState = {
  loading: null,
  errorMessage: {},
  profile: {},
  isEditing: null,
  otherProfile: {},
  isOtherProfileLoading: null
};

export function profileReducer(state = initialState, action) {
  switch (action.type) {
    case PROFILE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PROFILE_SET_DATA:
      setUserId(action.payload._id);
      return {
        ...state,
        profile: action.payload,
        loading: false,
      };
    case PROFILE_SET_DATA_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
      };
    case PROFILE_EDIT_START:
      return {
        ...state,
        isEditing: true,
      };
    case PROFILE_EDIT_SUCCESS:
      return {
        ...state,
        isEditing: false,
        profile: action.payload,
      };
    case PROFILE_EDIT_FAILURE:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case GET_OTHER_PROFILE_START:
      return {
        ...state,
        isOtherProfileLoading: true,
      };
    case GET_OTHER_PROFILE_SUCCESS:
      return {
        ...state,
        isOtherProfileLoading: false,
        otherProfile: action.payload,
      };
    case GET_OTHER_PROFILE_FAILURE:
      return {
        ...state,
        isOtherProfileLoading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}
